// Screen `general` — design/screens/WorkspaceGeneral.dc.html — owner: S10.
import { createFileRoute } from '@tanstack/react-router';
import { GeneralPage } from '../../../features/access/GeneralPage';

export const Route = createFileRoute('/_settings/settings/general')({
  component: GeneralPage,
});
